$(() => {
  $('.preventDefault>a').on('click',function(e){
    e.preventDefault();
  })
});
